module.exports = "/_next/static/images/CreateYourDynamicData@2x-d2a7b04ea65c60002055fc1b1a8c6644.png";